import { useEffect, useState } from 'react';

import { ApiPath, SipStatus } from 'enums';

export const useResponseEvents = (
  showResponse: boolean,
  setShowResponse: (showResponse: boolean) => void,
) => {
  const [eventStatus, setEventStatus] = useState<SipStatus>(SipStatus.CLOSE);
  const [failedFileId, setFailedFileId] = useState<{ id: string | null }>({ id: null });

  useEffect(() => {
    if (showResponse) {
      const sipSse = new EventSource(`${ApiPath.auth}/inspection-file/sse/metadata`);

      sipSse.onopen = () => {
        setEventStatus(SipStatus.OPEN);
      };

      sipSse.addEventListener(`metadata.read-completed`, e => {
        const parseData = JSON.parse(e.data);

        if (parseData?.status === SipStatus.SUCCESS) {
          setEventStatus(SipStatus.SUCCESS);
          setShowResponse(false);
          sipSse.close();
        }

        if (parseData?.status === SipStatus.FAILED) {
          setEventStatus(SipStatus.FAILED);
          setFailedFileId(parseData?.file?.id);
          setShowResponse(false);
          sipSse.close();
        }
      });

      sipSse.onerror = e => {
        setEventStatus(SipStatus.ERROR);
        setShowResponse(false);
        sipSse.close();
      };

      return () => {
        setEventStatus(SipStatus.CLOSE);
        setShowResponse(false);
        sipSse.close();
      };
    }
  }, [showResponse]);

  return { eventStatus, failedFileId };
};
